/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Estimate Unit Types
 */
export enum SessionEstimateItemUnitType {
    Hours = 'hours',
    Miles = 'miles',
    Days = 'days',
    Count = 'count',
    CostumeChanges = 'costume changes',
    Tags = 'tags',
    Doubles = 'doubles',
}
